import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CaseModel } from 'src/app/models/case.model';
import { DocumentModel } from 'src/app/models/document.model';
import { FileMenuActions, OpenMenuItems } from 'src/app/models/file-menu.model';
import { DocumentDataService } from 'src/app/services/document-data.service';
import { DocumentService } from 'src/app/services/document.service';

@Component({
  selector: 'tx-open-document',
  templateUrl: './open-document.component.html',
  styleUrls: ['./open-document.component.scss'],
})
export class OpenDocumentComponent implements OnInit {
  @Input() existingDocument: string | undefined = '';
  @Input() isPdf: boolean = false;
  @Input() isDirty: boolean = false;
  @Output() openDocument: EventEmitter<any> = new EventEmitter();
  @Output() openInNewTab: EventEmitter<any> = new EventEmitter();
  @Output() uploadDocument: EventEmitter<DocumentModel> = new EventEmitter();
  public preselectedContactId: string;
  public preselectedCaseId: string;
  public selectedCaseId: CaseModel | undefined;
  openMenuItems = OpenMenuItems;
  fileMenuActions = FileMenuActions;
  activeComponent: string;
  constructor(private documentService: DocumentService, private documentDataService: DocumentDataService) {
    this.activeComponent = this.openMenuItems.ClientCase;
    this.preselectedCaseId = this.documentDataService.getCasId();
    this.preselectedContactId = this.documentDataService.getCtcId();
  }

  ngOnInit(): void {}

  changeComponent(component: string) {
    this.activeComponent = component;
  }

  CaseSelected(cas: CaseModel) {
    this.selectedCaseId = cas;
  }
}
